import { env } from "./env";

import type { CfConfig } from "./shared/hocs/context/withConfig";

// Service base URLs live in env without the `/api` suffix; BACKEND_OPTIONS
// expects it. GATEWAY_URL already carries `/api` on some stacks — normalize so
// it is present exactly once.
const withApiSuffix = (baseUrl: string): string => {
  const trimmed = baseUrl.replace(/\/+$/, "");
  return trimmed.endsWith("/api") ? trimmed : `${trimmed}/api`;
};

// Derived once from the build-time env — `env` is frozen at module load, so the
// config is effectively a constant and must keep a stable reference (consumers
// use it as a `useMemo` dependency).
const config: CfConfig = {
  api: {
    gatewayUrl: withApiSuffix(env.GATEWAY_URL),
    agroevidenceUrl: withApiSuffix(env.AGROEVIDENCE_URL),
    iotUrl: withApiSuffix(env.IOT_URL),
    storesUrl: withApiSuffix(env.STORES_URL),
    sentinelUrl: withApiSuffix(env.SATELLITE_URL),
    automationUrl: withApiSuffix(env.AUTOMATION_URL),
    irrigationUrl: withApiSuffix(env.IRRIGATION_URL),
    telematicsUrl: withApiSuffix(env.TELEMATICS_URL),
    geolayersUrl: withApiSuffix(env.GEOLAYERS_URL),
    satelliteReportsUrl: env.SATELLITE_REPORTS_URL,
    maptiler_key: env.MAPTILER_API_KEY,
    // Per-farm value, computed at render time in the AsApplied map — the
    // config only carries a placeholder.
    lpisLayerName: "",
  },
  environment: env.ENVIRONMENT,
};

export { config };
